import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { FetchStatuses } from 'builder/modules/constants'
import { actions as userActions } from 'builder/modules/user'
import { actions, selectors } from 'builder/modules/resumeDistribution'

import { useUser } from 'builder/hooks/useUser'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import useWebsiteHost from 'builder/components/CIO-Dasboard-2.0/hooks/useWebsiteHost'

import { Spinner } from 'builder/components/Spinner'
import { Container } from 'builder/components/Container'
import DashboardHeader from './components/DashboardHeader'
import DashboardBanner from './components/DashboardBanner'
import { RecruiterSection } from './components/RecruiterSection/RecruiterSection'
import { SpinnerWrapper, Wrapper } from './styles'

export const ResumeDistributionDashboardView = () => {
  const user = useUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { getHost } = useWebsiteHost()

  const candidate = useTypedSelector(selectors.candidate)
  const distributionDates = useTypedSelector(selectors.distributionDates)
  const nextDistributionDate = useTypedSelector(selectors.nextDistributionDate)
  const distributedRecruiterCount = useTypedSelector(selectors.distributedRecruiterCount)
  const distributedRecruitersCountStatus = useTypedSelector(
    selectors.distributedRecruitersCountStatus,
  )

  const fetchUser = useCallback(() => {
    if (candidate && !user?.scopes.resumeDistributionCandidate) {
      dispatch(userActions.fetchUserRequest({ silent: true }))
    }
  }, [candidate, dispatch, user?.scopes.resumeDistributionCandidate])

  useEffect(() => {
    trackInternalEvent('rd_dashboard', { website_host: getHost })
    dispatch(actions.fetchCandidate())
    dispatch(actions.fetchDistributedRecruitersCount())
  }, [dispatch, getHost])

  useEffect(() => {
    if (candidate && !candidate?.fileUploadId) {
      navigate('/resume-distribution/invalid-document')
    }
    fetchUser()
  }, [candidate, fetchUser, navigate])

  if (!candidate || distributedRecruitersCountStatus === FetchStatuses.loading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    )
  }

  return (
    <Wrapper>
      <Container>
        <DashboardHeader candidate={candidate} />
      </Container>
      <Container>
        <DashboardBanner
          totalRecruiters={distributedRecruiterCount}
          nextDistribution={nextDistributionDate}
        />
      </Container>
      <RecruiterSection distributions={distributionDates} />
    </Wrapper>
  )
}
